module.exports = __webpack_public_path__ + "static/media/4540.76c0c6e1.jpg";